import axios from 'axios';

const defaultConfig = {
  timeout: 3000,
};
const httpService = axios.create(defaultConfig);
httpService.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
httpService.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const { config, code, message } = error;
    if (code === 'ECONNABORTED' || message === 'Network Error') {
      return new Promise((resolve) => {
        setTimeout(async (_) => {
          resolve(await httpService.request(config));
        }, defaultConfig.timeout);
      });
    }
    return Promise.reject(error);
  }
);

export default httpService;
